import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ChevronDown } from 'lucide-react';
import { rtlLanguages } from '../i18n/config';

const FAQItem = ({ question, answer, isOpen, onToggle, isRTL }) => {
  return (
    <div className="border-b border-slate-200 dark:border-slate-700 last:border-b-0">
      <button
        onClick={onToggle}
        className={`w-full py-5 px-6 ${isRTL ? 'text-right' : 'text-left'} flex items-center justify-between gap-4 hover:bg-slate-50 dark:hover:bg-slate-800/50 transition-colors duration-200`}
      >
        <span className="text-lg font-semibold text-slate-900 dark:text-white">
          {question}
        </span>
        <ChevronDown
          className={`w-5 h-5 text-sky-700 dark:text-sky-300 flex-shrink-0 transition-transform duration-300 ${
            isOpen ? 'rotate-180' : ''
          }`}
        />
      </button>
      <div
        className={`overflow-hidden transition-all duration-300 ${
          isOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="px-6 pb-5 text-slate-600 dark:text-slate-300 leading-relaxed">
          {answer}
        </div>
      </div>
    </div>
  );
};

const FAQ = () => {
  const { t, i18n } = useTranslation();
  const isRTL = rtlLanguages.includes(i18n.language);
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: t('faq.q1.question'),
      answer: t('faq.q1.answer')
    },
    {
      question: t('faq.q2.question'),
      answer: t('faq.q2.answer')
    },
    {
      question: t('faq.q3.question'),
      answer: t('faq.q3.answer')
    },
    {
      question: t('faq.q4.question'),
      answer: t('faq.q4.answer')
    },
    {
      question: t('faq.q5.question'),
      answer: t('faq.q5.answer')
    },
    {
      question: t('faq.q6.question'),
      answer: t('faq.q6.answer')
    },
    {
      question: t('faq.q7.question'),
      answer: t('faq.q7.answer')
    },
    {
      question: t('faq.q8.question'),
      answer: t('faq.q8.answer')
    },
    {
      question: t('faq.q9.question'),
      answer: t('faq.q9.answer')
    },
    {
      question: t('faq.q10.question'),
      answer: t('faq.q10.answer')
    }
  ];

  const handleToggle = (index) => {
    const isOpening = openIndex !== index;
    setOpenIndex(openIndex === index ? null : index);
    
    if (isOpening && typeof window !== 'undefined' && typeof window.gtag !== 'undefined') {
      window.gtag('event', 'opened_faq', {
        event_category: 'engagement',
        question: faqs[index].question
      });
    }
  };

  return (
    <section id="faq" className="py-20 px-4 sm:px-6 lg:px-8 bg-white/50 dark:bg-slate-800/50">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl sm:text-5xl font-bold text-slate-900 dark:text-white mb-4">
            {t('faq.title')}
          </h2>
          <p className="text-xl text-slate-600 dark:text-slate-300">
            {t('faq.subtitle')}
          </p>
        </div>

        <div className="bg-white dark:bg-slate-800 rounded-2xl shadow-xl border border-slate-200 dark:border-slate-700 overflow-hidden">
          {faqs.map((faq, index) => (
            <FAQItem
              key={index}
              question={faq.question}
              answer={faq.answer}
              isOpen={openIndex === index}
              onToggle={() => handleToggle(index)}
              isRTL={isRTL}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
